import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { FileCopyIcon as FileCopy } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type GridExpressProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const DuplicateButton: React.FC<GridExpressProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore } = rootStore;

    return (
      <Button
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<FileCopy />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {label === undefined ? "Duplicar y editar" : label}
      </Button>
    );
  }
);
